import React from 'react';
import { useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import CloseIcon from '@material-ui/icons/Close';
import { IconButton, Box, Grid, Container } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import translate from '../../actions/translate';
import updateAnalytics from '../../actions/updateAnalytics';

function getModalStyle() {
  const top = 50;
  const left = 50;

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

const useStyles = makeStyles((theme) => ({
  paper: {
    position: 'absolute',
    [theme.breakpoints.down('sm')]: {
      width: '90%',
      height: '95%',
    },
    [theme.breakpoints.up('md')]: {
      width: '500px',
      height: '700px',
    },
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
  },
}));

export default function SimpleModal() {
  const classes = useStyles();
  // getModalStyle is not a pure function, we roll the style only on the first render
  const [modalStyle] = React.useState(getModalStyle);
  const [open, setOpen] = React.useState(false);
  const alias = useSelector((state) => state.formState.Restaurant_alias);
  const menuId = useSelector((state) => state.formState.menu_id);
  const restaurantId = useSelector((state) => state.formState.Restaurant_id);

  const handleOpen = () => {
    updateAnalytics(
      {
        menuOpened: true,
      },
      restaurantId
    );
    setOpen(true);
  };

  const handleClose = () => {
    console.log('CLICKED CLOSE');
    setOpen(false);
  };

  const body = (
    <Container maxWidth="sm">
      <div style={modalStyle} className={classes.paper}>
        <Box mb={-6}>
          <Grid container item justify="flex-start">
            {' '}
            <IconButton
              variant="outlined"
              onClick={() => {
                handleClose();
              }}
            >
              <CloseIcon />
            </IconButton>
          </Grid>
        </Box>
        <iframe
          height="100%"
          width="101%"
          frameBorder="0"
          // width={matches ? '500px' : '101%'}
          src={
            process.env.REACT_APP_ENV === 'dev'
              ? `https://qa.qmenu.us/#/${alias}/menu/${menuId}`
              : `https://qmenu.us/#/${alias}/menu/${menuId}`
          }
          title="Online Menu"
        />{' '}
      </div>
    </Container>
  );

  return (
    <div>
      <Button
        variant="contained"
        color="primary"
        type="button"
        onClick={handleOpen}
      >
        {translate('Preview Menu Demo *')}
      </Button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        {body}
      </Modal>
    </div>
  );
}
